import { render, staticRenderFns } from "./PosterTemplates.vue?vue&type=template&id=0d0c6a3e&scoped=true&"
import script from "./PosterTemplates.vue?vue&type=script&lang=js&"
export * from "./PosterTemplates.vue?vue&type=script&lang=js&"
import style0 from "./PosterTemplates.vue?vue&type=style&index=0&id=0d0c6a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0c6a3e",
  null
  
)

export default component.exports